// ────────────────────────────────────────────────
// BASKET-ONLY SCRIPT – standalone, no calculator dependencies
// Load this globally in theme.liquid with <script src="{{ 'basket.js' | asset_url }}" defer></script>
// ────────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', () => {

  const BASIN_ENDPOINT = 'https://usebasin.com/f/53bcf91d96ae'; // your endpoint

  // Update count badge
  function updateBasketCount() {
    const countEl = document.getElementById('quote-count');
    if (!countEl) return;
    const quotes = JSON.parse(localStorage.getItem('quoteBasket') || '[]');
    const count = quotes.length;
    countEl.textContent = count;
    countEl.style.display = count > 0 ? 'block' : 'none';
  }

  // Render basket items + banner
  function renderQuoteBasket() {
    const list = document.getElementById('quote-list');
    if (!list) return;

    const quotes = JSON.parse(localStorage.getItem('quoteBasket') || '[]');

    // Multi-Order Discount Banner
    const discount = calculateMultiOrderDiscount(quotes);
    const banner = document.getElementById('multi-discount-banner');

    if (banner) {
      if (discount.savings > 0) {
        banner.innerHTML = `
          <div style="background: #33404f; padding: 18px; border-radius: 12px; text-align: center; border: 3px solid #bfaa6f; margin-bottom: 20px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);">
            <strong style="font-size: 18px; color: #bfaa6f;; display: inline-flex; align-items: center; gap: 8px;">
  <img 
    src="https://cdn.shopify.com/s/files/1/0979/0236/2999/files/premium.png" 
    alt="Multi Order Discount" 
    style="height: 31px; width: auto; display: block;"
  >
  MULTI-ORDER-DISCOUNT UNLOCKED
</strong><br>
            <span style="font-size: 33px; font-weight: bold; color: #ffffff;">
              SAVE £${discount.savings.toFixed(2)} (${discount.savingsPercent}%)
            </span><br>
            <span style="font-size: 18px; color: #ffffff; font-weight: 600;">
              Enhanced Volume Discount Applied
            </span><br><br>
            <small style="color: #ffffff; font-size: 16px;">
              New combined total (exc VAT): £${discount.combinedTotalExc.toFixed(2)}
            </small>
          </div>`;
      } else {
        let message = '';
        if (quotes.length === 0) {
          message = 'Add your first quote to start building your basket!';
        } else if (quotes.length === 1) {
          message = 'Add one more quote to unlock multi-order savings!';
        } else {
          message = 'Add even more quotes to increase your savings further!';
        }

        banner.innerHTML = `
          <div style="background: #33404f; padding:16px; border-radius:10px; text-align:center; color:#ffffff; font-size:17px; margin-bottom: 20px; border: 3px solid #bfaa6f;">
            ${message}
            <br><small style="opacity:0.8;">The more you add, the bigger the discount!</small>
          </div>`;
      }
    }

    list.innerHTML = '';

    if (quotes.length === 0) {
      list.innerHTML = '<p style="text-align:center; color:#999;">No quotes in basket yet</p>';
      return;
    }

    quotes.forEach((quote, index) => {
      const attachedUrls = Array.isArray(quote.artworkUrls) && quote.artworkUrls.length > 0
        ? quote.artworkUrls.join(', ')
        : 'No files uploaded';

      const item = document.createElement('div');
      item.className = 'quote-item';
      item.style.cssText = 'padding: 15px; border-bottom: 1px solid #eee; background: #ffffff; border-radius: 8px; margin-bottom: 10px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);';
      item.innerHTML = `
        <div style="flex-shrink: 0;">
          <img src="${quote.imageUrl || 'https://via.placeholder.com/120?text=No+Image'}" alt="${quote.product}" style="width: 120px; height: 120px; object-fit: contain; border: 2px solid #bfaa6f; border-radius: 8px; background: white;">
        </div>
        <div style="flex-grow: 1;">
          <h4 style="margin: 0 0 10px; color: #33404f;">${quote.product}</h4>
          <p><strong>Quantity:</strong> ${quote.quantity}</p>
          <p><strong>Colour:</strong> ${quote.colour}</p>
<p><strong>Decoration:</strong> ${quote.decoration.replace(/print to 1 (side|panel)/gi, '').trim()}</p>
          <p><strong>Text/Logo:</strong> ${quote.text}</p>
          <p><strong>Lead time:</strong> ${quote.leadtimeRaw ? (Array.isArray(quote.leadtimeRaw) ? quote.leadtimeRaw[0] : quote.leadtimeRaw) : 'Not selected'}</p>
          <p><strong>Estimated delivery:</strong> <span class="fresh-delivery" data-leadtime='${JSON.stringify(quote.leadtimeRaw || ["Not selected"])}'>Calculating...</span></p>
          <p><strong>Artwork URLs:</strong> ${attachedUrls}</p>
          <p><strong>Unit Price:</strong> ${quote.unitCost}</p>
          <p><strong>Total exc VAT:</strong> ${quote.totalExc}</p>
          <p><strong>Total inc VAT:</strong> ${quote.totalInc}</p>
          <p><strong>Customer:</strong> ${quote.customerName} | ${quote.customerEmail} | ${quote.customerMobile}</p>
          <button 
  onclick="removeQuote(${index})" 
  style="margin-top: 10px; background: #33404f; color: white; border: none; padding: 8px 16px; border-radius: 6px; cursor: pointer; display: inline-flex; align-items: center; gap: 8px;"
>
  <!-- Inline SVG trash icon – 21px height, white stroke -->
  <svg 
    width="21" 
    height="21" 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    style="flex-shrink: 0;"
  >
    <path 
      d="M3 6H21M19 6V20C19 21.1046 18.1046 22 17 22H7C5.89543 22 5 21.1046 5 20V6M8 6V4C8 2.89543 8.89543 2 10 2H14C15.1046 2 16 2.89543 16 4V6M10 11V17M14 11V17" 
      stroke="white" 
      stroke-width="2" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
  </svg>
  REMOVE
</button>
        </div>
      `;
      list.appendChild(item);
    });
  }

  window.removeQuote = function(index) {
    let quotes = JSON.parse(localStorage.getItem('quoteBasket') || '[]');
    quotes.splice(index, 1);
    localStorage.setItem('quoteBasket', JSON.stringify(quotes));
    renderQuoteBasket();
    updateBasketCount();
  };

  // Panel open/close
  const basketPanel = document.getElementById('quote-basket-panel');
  const basketOverlay = document.getElementById('quote-basket-overlay');
  const closeBtn = document.getElementById('close-quote-basket');

  if (basketPanel && basketOverlay) {
    // Open
    document.addEventListener('click', (e) => {
      if (e.target.closest('#quote-basket-toggle')) {
        e.preventDefault();
        e.stopPropagation();
        renderQuoteBasket();
        basketPanel.style.display = 'block';
        basketOverlay.style.display = 'block';
        basketPanel.classList.add('open');
      }
    });

    // Close
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        basketPanel.classList.remove('open');
        basketOverlay.style.display = 'none';
        basketPanel.style.display = 'none';
      });
    }

    if (basketOverlay) {
      basketOverlay.addEventListener('click', () => {
        basketPanel.classList.remove('open');
        basketPanel.style.display = 'none';
        basketOverlay.style.display = 'none';
      });
    }
  }

  // Initial run
  updateBasketCount();
  setInterval(updateBasketCount, 1000);
});

// Multi-order discount helper (needed for banner)
function calculateMultiOrderDiscount(quotes) {
  if (quotes.length <= 1) {
    return { savings: 0, savingsPercent: 0, combinedTotalExc: 0 };
  }

  let grandBase = 0;
  let sumIndividualTotals = 0;

  quotes.forEach(quote => {
    grandBase += parseFloat(quote.baseCostWithFixed) || 0;
    sumIndividualTotals += parseFloat(quote.individualTotalExc) || 0;
  });

  const combinedMarkup = calculateMarkup(grandBase);
  const combinedTotalExc = Math.round((grandBase + combinedMarkup) * 100) / 100;

  const savings = Math.round((sumIndividualTotals - combinedTotalExc) * 100) / 100;
  const savingsPercent = sumIndividualTotals > 0 ? Math.round((savings / sumIndividualTotals) * 100) : 0;

  return { savings, savingsPercent, combinedTotalExc };
}

// Markup helper (needed for discount calculation)
function calculateMarkup(baseCost) {
  if (baseCost < 144) return 50;
  if (baseCost < 350) return baseCost * 0.35;
  if (baseCost < 1000) return baseCost * 0.28;
  if (baseCost < 2500) return baseCost * 0.25;
  return baseCost * 0.24;
}